<script>
import { Doughnut as chart } from 'vue-chartjs';
import bc from './base-chart';
import chartjsPluginDatalabels from 'chartjs-plugin-datalabels';

const FONT_SIZE = 14; // タイトルのフォントサイズ
const MAX_LEN = 7;    // タイトルの1行当たりの最大文字数

// データラベル描画関数
export const datalabelValueFormatter = (value, context) => {
  if (!value) {
    return '';
  }
  const dataset = context.dataset;
  const meta = dataset._meta[Object.keys(dataset._meta)[0]];
  // ★絶対値で判定するように変更
  return Math.abs(value / meta.total) > 0.05 ? value : ''; // 全体の5%未満のデータラベルは非表示
};
export const datalabelNameFormatter = (value, context) => {
  let result = '';
  if (datalabelValueFormatter(value, context)) {
    const label = context.chart.data.labels[context.dataIndex];
    result = label ? label.replaceAll(' ', '\n') : result; // スペースで改行
  }
  return result;
};
export const appDatalabelNameFormatter = (value, context) => {
  let result = '';
  if (datalabelValueFormatter(value, context)) {
    const label = context.chart.data.labels[context.dataIndex];
    result = label ? label.replaceAll(' ', '\n') : result; // スペースで改行
    if (context.datasetIndex !== 0) {
      result = context.dataset.labels[context.dataIndex];
    }
  }
  return result;
};

export default {
  extends: chart,
  mixins: [bc],
  data() {
    return {
      title: '[]',
      chartInstance: null,
    };
  },
  watch: {
    parentTitle(v) {
      this.title = this.splitTitle(v);
      if (this.chartInstance) {
        this.chartInstance.draw(0);
      }
    },
  },
  computed: {
    TITLE_FONT() {
      const fontStyle = 'normal';
      const fontFamily = 'Helvetica Neue';
      return Chart.helpers.fontString(FONT_SIZE, fontStyle, fontFamily);
    },
  },
  mounted() {
    if (this.gadgetVersion >= 3) {
      this.addPlugin(chartjsPluginDatalabels);
      this.addPlugin({
        beforeDraw: (chartInstance) => {
          this.chartInstance = chartInstance;
          this.fillTitleText(chartInstance);
        },
        afterDatasetsDraw: (chartInstance) => {
          this.title = this.splitTitle(this.parentTitle);
          this.fillTitleText(chartInstance);
        },
      });
    }
  },
  methods: {
    // グラフの中心にタイトル描画
    fillTitleText(chartInstance) {
      const ctx = chartInstance.chart.ctx;
      ctx.font = this.TITLE_FONT;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const titleAry = JSON.parse(this.title);
      const measure = ctx.measureText('あ'); // 高さ計測
      const height = measure.fontBoundingBoxAscent + measure.fontBoundingBoxDescent;
      const x = chartInstance.width / 2;
      const y = (chartInstance.height / 2) - (titleAry.length - 1) * height / 2;
      for (let i = 0; i < titleAry.length; i++) {
        const title = titleAry[i];
        ctx.fillText(title, x, y + (i * height));
      }
    },
    splitTitle(value) {
      const str = value;
      const result = [];
      if (!str) {
        return JSON.stringify(result);
      }
      const ary = str.split(/\s+/); // HTMLのようにスペースで自動改行
      for (let i = 0; i < ary.length; i++) {
        const partStr = ary[i];
        if (partStr.length > MAX_LEN) { // 1行を最大7文字とする
          const rows = Math.ceil(partStr.length / MAX_LEN);
          for (let j = 0; j < rows; j++) {
            result.push(partStr.slice(j * MAX_LEN, (j + 1) * MAX_LEN));
          }
        } else {
          if (ary.length > 2 && result.length > 0 && (result[result.length - 1].length + partStr.length < MAX_LEN)) {
            // 3行以上のときスペースで区切った文節が短ければ結合
            result[result.length - 1] = `${result[result.length - 1]} ${partStr}`;
          } else {
            if (partStr) {
              result.push(partStr);
            }
          }
        }
      }
      return JSON.stringify(result);
    },
  },
};
</script>